import Cookies from 'universal-cookie';

/**
 * Retrieves the Google Analytics client ID from the global `ga` object.
 */
function getGoogleAnalyticsClientID() {
  // GA's own script can throw here before it has loaded, and a meta property must never break the event.
  try {
    return window.ga?.getAll?.()?.[0]?.get('clientId');
  } catch {
    return undefined;
  }
}

/**
 * Retrieves the Segment anonymous ID from cookies.
 */
function getSegmentAnonymousId() {
  const cookies = new Cookies();
  const id = cookies.get('ajs_anonymous_id');
  if (id != null) {
    return id;
  }

  // Segment JSON.stringifies a string before saving it as a cookie,
  // so it adds extra quotes around that string. We try to parse it,
  // and if it succeeds, that will return the string, otherwise we
  // just sent the value as it is.
  try {
    return JSON.parse(id);
  } catch {
    return id;
  }
}

/**
 * Constructs meta properties attached to every analytics event. Shared by the
 * workspace-scoped `useAnalytics` and the pre-auth login tracking so both send
 * the same standard properties. Dependency-light (only reads `window`/cookies)
 * so it can be imported on the login page without pulling in the analytics
 * service's workspace/auth chain.
 */
export function getAnalyticsMetaProperties() {
  return {
    path: window.location.pathname,
    referrer: document.referrer,
    search: window.location.search,
    title: document.title,
    url: window.location.href,
    user_agent: navigator.userAgent,
    segment_anonymous_id: getSegmentAnonymousId(),
    google_client_id: getGoogleAnalyticsClientID(),
  };
}
